<script setup lang="ts">
/**
 * Use the query para.S
 */
const { config } = useParams()

/**
 * Use the "world" framework.
 */
const { onlyRoots, worldFramework, framework } = useFramework()

/**
 * Use i18n.
 */
const { t } = useI18n()

/**
 * Top level dimensions.
 */
const dimensions = computed(() => {
    return onlyRoots(unref(framework))
})

/**
 * Items for the dropdown menu.
 */
const dropdownItems = computed(() => {
    return onlyRoots(unref(worldFramework)).map(({ name, id }) => ({
        label: name,
        action: () => (config.dimension = id)
    }))
})
</script>

<template>
    <div
        class="flex flex-shrink-0 flex-col bg-neutral p-4 !pb-0 lg:w-1/3 lg:overflow-y-auto lg:p-8"
    >
        <div class="mb-8 flex flex-col gap-2">
            <h1 class="text-2xl font-bold uppercase text-black">
                {{ t('overview-title') }}
            </h1>
            <p class="font-serif">
                {{ t('overview-long-description') }}
            </p>
        </div>

        <div class="mb-6 flex flex-col gap-8">
            <div
                v-for="dimension in dimensions"
                :key="dimension.id"
                class="flex flex-col items-start gap-2"
            >
                <h2
                    :style="coloringStyle(dimension.labelColor)"
                    class="rounded-full px-4 py-1 font-rubik text-lg font-bold uppercase"
                >
                    {{ dimension.name }}
                </h2>
                <p class="font-sans">
                    {{ dimension.description }}
                </p>
            </div>
        </div>

        <div class="flex-1" />

        <div
            class="sticky bottom-0 -mx-4 grid grid-flow-row justify-center gap-2 bg-zinc-300/50 py-4 backdrop-blur-[8px] lg:-mx-8 lg:grid-flow-col"
        >
            <UiButton
                class="w-full font-rubik font-bold uppercase"
                @click="config.showFramework = true"
            >
                {{ t('explore-framework') }}
            </UiButton>
            <UiDropdown primary simple direction="top" :items="dropdownItems">
                <template #trigger="{ click }">
                    <UiButton
                        primary
                        simple
                        class="w-full font-rubik font-bold uppercase"
                        @click="click()"
                    >
                        {{ t('explore-data') }}
                    </UiButton>
                </template>
            </UiDropdown>
        </div>
    </div>
</template>